class TabbedMegaMenu {
  constructor(element) {
    this.element = element;
    this.tabs = Array.from(
      element.querySelectorAll("[data-mega-tab]")
    );

    this.panels = Array.from(
      element.querySelectorAll("[data-mega-panel]")
    );

    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("mouseenter", () => {
        this.activateTab(tab);
      });

      tab.addEventListener("focus", () => {
        this.activateTab(tab);
      });


    });
  }

  activateTab(activeTab) {
    const targetId = activeTab.dataset.megaTab;

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;

      tab.classList.toggle("is-active", isActive);

      tab.setAttribute(
        "aria-selected",
        isActive ? "true" : "false"
      );
    });

    this.panels.forEach((panel) => {
      const isActive =
        panel.dataset.megaPanel === targetId;

      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  }
}

function initialiseTabbedMegaMenus(scope = document) {
  scope
    .querySelectorAll("[data-tabbed-mega-menu]")
    .forEach((element) => {
      if (element.dataset.initialised === "true") {
        return;
      }

      element.dataset.initialised = "true";

      new TabbedMegaMenu(element);
    });
}

document.addEventListener("DOMContentLoaded", () => {
  initialiseTabbedMegaMenus();
});

document.addEventListener("shopify:section:load", (event) => {
  initialiseTabbedMegaMenus(event.target);
});